import { generateQuery } from 'utils';
import http from 'utils/http';

export const getSegments = (params = {}) => {
  const query = generateQuery([
    params.search ? `search=${encodeURIComponent(params.search)}` : '',
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/segments/${query}`)
    .then((res) => res.data);
};

export const getSegmentStatistics = () =>
  http
    .get('v1/organizations/{{organizationId}}/segments/statistics/')
    .then((res) => res.data);

export const getSegment = (segmentId) =>
  http
    .get(`v1/organizations/{{organizationId}}/segments/${segmentId}/`)
    .then((res) => res.data);

export const createSegment = (data) =>
  http
    .post('v1/organizations/{{organizationId}}/segments/', data)
    .then((res) => res.data);

export const updateSegment = (segmentId, data) =>
  http
    .patch(`v1/organizations/{{organizationId}}/segments/${segmentId}/`, data)
    .then((res) => res.data);

export const deleteSegment = (segmentId) =>
  http
    .delete(`v1/organizations/{{organizationId}}/segments/${segmentId}/`)
    .then((res) => res.data);

export const getSegmentPreview = (segmentId) =>
  http
    .get(`v1/organizations/{{organizationId}}/segments/${segmentId}/preview/`)
    .then((res) => res.data);

export const previewSegment = (data) =>
  http
    .post('v1/organizations/{{organizationId}}/segments/preview/', data)
    .then((res) => res.data);

export const getSegmentCustomers = (segmentId, params = {}) => {
  const query = generateQuery([
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/segments/${segmentId}/customers/${query}`)
    .then((res) => res.data);
};
